<template>
  <BContainer
    class="px-0"
    fluid
  >

    <div class="py-2 w-100 border-bottom font-weight-bold text-muted mb-3">
      FSO Tasks
    </div>

    <BRow
      v-if="busy"
      class="mb-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h6 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="assignedTasks.rows.length === 0"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="4"
        />
        <p class="h6 py-2">
          <strong>No FSO tasks found</strong>
        </p>
      </BCol>
    </BRow>

    <BCardGroup
      v-else
      columns
    >
      <BCard
        v-for="officer in assignedTasks.rows"
        :key="officer.sso_id"
      >
        <BCardText>
          <RouterLink
            :to="{
              name: 'asm.tracking.officer-tasks',
              params: {
                officer: officer.id
              }
            }"
          >
            <div class="d-flex gap-4 mb-2">
              <BAvatar
                v-if="officer.photo_url"
                :src="computedProfilePath(officer.photo_url)"
                variant="primary"
                size="50px"
              />
              <BAvatar
                v-else
                variant="primary"
                size="50px"
                :text="String(officer?.first_name).charAt(0) + String(officer?.last_name).charAt(0)"
              />
              <div class="d-flex flex-column justify-content-center">
                <div
                  class="font-weight-bolder"
                  style="font-size: 0.8rem;"
                >
                  {{ officer?.first_name }} {{ officer?.last_name }}
                </div>
                <div
                  class="mt-1 text-dark"
                  style="font-size: 0.7rem;"
                >
                  {{ Array.from(officer?.clusters || []).map(cluster => cluster.cluster_name).join(', ') || '' }}
                </div>
              </div>
            </div>
          </RouterLink>
        </BCardText>

        <BCardText
          v-if="officer.tasks.length === 0"
          class="text-muted"
        >
          No tasks assigned
        </BCardText>

        <BCardText
          v-else
        >
          <Officer
            v-for="task in officer.tasks"
            :key="task.id"
            :task="task"
            :officer="officer"
            class="mt-2"
          />
        </BCardText>

      </BCard>
    </BCardGroup>
  </BContainer>
</template>
<script>
import Officer from '@/views/asm/dashboard/components/Officer.vue'

export default {
  name: 'ASMDashboardOfficers',

  components: {
    Officer
  },

  props: {
    busy: {
      type: Boolean,
      default: () => false
    },
    assignedTasks: {
      type: Object,
      default: () => ({
        totalRows: 0,
        rows: []
      })
    }
  },

  methods: {
    computedProfilePath (photoUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/${photoUrl}`
    }
  }
}
</script>
